module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteConfirm":"Are you sure to delete this tax rate?"},"et":{"deleteConfirm":"Are you sure to delete this tax rate?"},"ru":{"deleteConfirm":"Are you sure to delete this tax rate?"}}')
  delete Component.options._Ctor
}
